import { useMemo } from 'react';

import { useParams } from '../../container/Router';

export default function useIsDirectBuy() {
    const params = useParams();

    return useMemo(() =>
        !!params.direct_buy_sku ||
        !!params.db_unatt ||
        !!params.db_attunu ||
        !!params.db_ctzdevnu ||
        !!params.db_ru ||
        !!params.db_discount, [ params ]);
}
